<div class="content">
  <h3>{{ T_SCOPE + '.title' | translate }}</h3>
  <div class="message">
    {{ T_SCOPE + '.message' | translate }}
  </div>
</div>
